import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';

export const PaymentDetailsAction = ({
  resource,
}) => {
  const { refreshPageContentCollection, loadPageContentLink } = usePageContentContext();
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  const makeCurrent = async (creditCardID) => {
    try {
      await resource.relationship(fr.relationships.makeCreditCardPaymentMethodCurrent.name).link('related').put({
        ID: creditCardID,
        attributes: {},
      }, { deprecatedAllowAlterOfRelation: true }); // This is legacy code, we should not use deprecatedAllowAlterOfRelation in new code
      displaySuccess(`Card ${resource.attr('paymentMethodInformation')} is now your current payment method.`);
      refreshPageContentCollection();
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <>
      {resource.withRelationship(fr.relationships.makeCreditCardPaymentMethodCurrent.name, (rel) => {
        return (
          <FDSecondaryActionButton
            label={rel.meta('prompt')}
            size={'sm'}
            onClick={() => makeCurrent(resource.attr('id'))}
            icon={rel.meta('icon')}
            disabled={!(rel.meta('actions')?.includes('PUT'))}
          />
        );
      }, () => null)}
      {resource.withRelationship(fr.relationships.makeAccountDebitPaymentMethodCurrent.name, (rel) => {
        return (
          <FDSecondaryActionButton
            label={rel.meta('prompt')}
            size={'sm'}
            onClick={() => loadPageContentLink(rel.link('related'))}
            icon={rel.meta('icon')}
            disabled={!(rel.meta('actions')?.includes('GET'))}
          />
        );
      }, () => null)}
    </>);
};

PaymentDetailsAction.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
